import React from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionFormTypes } from '../../services/filtering/filter-form-render-service/option-form-types';
import { stringFilterOperators, dateFilterOperators } from './reference-data-criteria-arguments';
import { messages } from './messages';

export const containsOperators = [
  {
    id: 'contains',
    displayName: <FormattedMessage {...messages.contains} />,
    value: 'BeginsWith',
  },
  {
    id: 'doesNotContain',
    displayName: <FormattedMessage {...messages.doesNotContain} />,
    value: 'DoesNotBeginWith',
  },
];

export const stringOperators = [
  {
    id: stringFilterOperators.isBlank,
    displayName: <FormattedMessage {...messages.isBlank} />,
    value: 'Empty',
  },
  {
    id: stringFilterOperators.isNotBlank,
    displayName: <FormattedMessage {...messages.isNotBlank} />,
    value: 'NotEmpty',
  },
  {
    id: stringFilterOperators.equals,
    displayName: <FormattedMessage {...messages.equals} />,
    value: 'Equals',
  },
  {
    id: stringFilterOperators.doesNotEqual,
    displayName: <FormattedMessage {...messages.doesNotEqual} />,
    value: 'NotEqual',
  },
  {
    id: stringFilterOperators.startsWith,
    displayName: <FormattedMessage {...messages.startsWith} />,
    value: 'BeginsWith',
  },
  {
    id: stringFilterOperators.doesNotStartWith,
    displayName: <FormattedMessage {...messages.doesNotStartWith} />,
    value: 'DoesNotBeginWith',
  },
  {
    id: stringFilterOperators.endsWith,
    displayName: <FormattedMessage {...messages.endsWith} />,
    value: 'EndsWith',
  },
  {
    id: stringFilterOperators.doesNotEndWith,
    displayName: <FormattedMessage {...messages.doesNotEndWith} />,
    value: 'DoesNotEndWith',
  },
  {
    id: stringFilterOperators.contains,
    displayName: <FormattedMessage {...messages.contains} />,
    value: 'Contains',
  },
  {
    id: stringFilterOperators.doesNotContain,
    displayName: <FormattedMessage {...messages.doesNotContain} />,
    value: 'DoesNotContain',
  },
];

export const advancedComparisonOperators = [
  {
    id: 'greaterThan',
    displayName: <FormattedMessage {...messages.greaterThan} />,
    value: 'Gt',
  },
  {
    id: 'greaterThanOrEqualTo',
    displayName: <FormattedMessage {...messages.greaterThanOrEqualTo} />,
    value: 'Gte',
  },
  {
    id: 'lessThan',
    displayName: <FormattedMessage {...messages.lessThan} />,
    value: 'Lt',
  },
  {
    id: 'lessThanOrEqualTo',
    displayName: <FormattedMessage {...messages.lessThanOrEqualTo} />,
    value: 'Lte',
  },
  {
    id: 'equalTo',
    displayName: <FormattedMessage {...messages.equalTo} />,
    value: 'Eq',
  },
  {
    id: 'notEqualTo',
    displayName: <FormattedMessage {...messages.notEqualTo} />,
    value: 'Ne',
  },
];

export const dateOperators = [
  {
    id: dateFilterOperators.dateToday,
    displayName: <FormattedMessage {...messages.dateToday} />,
    value: dateFilterOperators.dateToday,
  },
  {
    id: dateFilterOperators.dateYesterday,
    displayName: <FormattedMessage {...messages.dateYesterday} />,
    value: dateFilterOperators.dateYesterday,
  },
  {
    id: dateFilterOperators.dateLastWeek,
    displayName: <FormattedMessage {...messages.dateLastWeek} />,
    value: dateFilterOperators.dateLastWeek,
  },
  {
    id: dateFilterOperators.dateLast30Days,
    displayName: <FormattedMessage {...messages.dateLast30Days} />,
    value: dateFilterOperators.dateLast30Days,
  },
  {
    id: dateFilterOperators.dateOnOrBefore,
    displayName: <FormattedMessage {...messages.dateOnOrBefore} />,
    value: dateFilterOperators.dateOnOrBefore,
  },
  {
    id: dateFilterOperators.dateOnOrAfter,
    displayName: <FormattedMessage {...messages.dateOnOrAfter} />,
    value: dateFilterOperators.dateOnOrAfter,
  },
  {
    id: dateFilterOperators.dateCustomRange,
    displayName: <FormattedMessage {...messages.dateCustomRange} />,
    value: dateFilterOperators.dateCustomRange,
  },
];

export const orderDateOperators = [
  {
    id: dateFilterOperators.dateToday,
    advanced: true,
    displayName: <FormattedMessage {...messages.dateToday} />,
    value: dateFilterOperators.dateToday,
  },
  {
    id: dateFilterOperators.dateYesterday,
    displayName: <FormattedMessage {...messages.dateYesterday} />,
    value: dateFilterOperators.dateYesterday,
  },
  {
    id: dateFilterOperators.dateLastWeek,
    displayName: <FormattedMessage {...messages.dateLastWeek} />,
    value: dateFilterOperators.dateLastWeek,
  },
  {
    id: dateFilterOperators.dateLast30Days,
    displayName: <FormattedMessage {...messages.dateLast30Days} />,
    value: dateFilterOperators.dateLast30Days,
  },
  {
    id: dateFilterOperators.dateThisMonth,
    displayName: <FormattedMessage {...messages.dateThisMonth} />,
    value: dateFilterOperators.dateThisMonth,
  },
  {
    id: dateFilterOperators.dateLastMonth,
    displayName: <FormattedMessage {...messages.dateLastMonth} />,
    value: dateFilterOperators.dateLastMonth,
  },
  {
    id: dateFilterOperators.dateWithinThePastXDays,
    advanced: true,
    displayName: <FormattedMessage {...messages.dateWithinThePastXDays} />,
    value: dateFilterOperators.dateWithinThePastXDays,
  },
  {
    id: dateFilterOperators.dateWithinTheNextXDays,
    advanced: true,
    displayName: <FormattedMessage {...messages.dateWithinTheNextXDays} />,
    value: dateFilterOperators.dateWithinTheNextXDays,
  },
  {
    id: dateFilterOperators.dateXDaysAgoOrMore,
    advanced: true,
    displayName: <FormattedMessage {...messages.dateXDaysAgoOrMore} />,
    value: dateFilterOperators.dateXDaysAgoOrMore,
  },
  {
    id: dateFilterOperators.dateXDaysAheadOrMore,
    advanced: true,
    displayName: <FormattedMessage {...messages.dateXDaysAheadOrMore} />,
    value: dateFilterOperators.dateXDaysAheadOrMore,
  },
  {
    id: dateFilterOperators.dateOnOrBefore,
    advanced: true,
    displayName: <FormattedMessage {...messages.dateOnOrBefore} />,
    value: dateFilterOperators.dateOnOrBefore,
  },
  {
    id: dateFilterOperators.dateOnOrAfter,
    advanced: true,
    displayName: <FormattedMessage {...messages.dateOnOrAfter} />,
    value: dateFilterOperators.dateOnOrAfter,
  },
  {
    id: dateFilterOperators.dateCustomRange,
    displayName: <FormattedMessage {...messages.dateCustomRange} />,
    value: dateFilterOperators.dateCustomRange,
  },
];

export const advancedDateOperators = orderDateOperators.filter((filter) => filter.advanced);

const isOperator = {
  id: 'is',
  displayName: <FormattedMessage {...messages.is} />,
  value: 'equals',
};

const isNotOperator = {
  id: 'isNot',
  displayName: <FormattedMessage {...messages.isNot} />,
  value: 'notEquals',
};

const isEmptyOperator = {
  id: 'empty',
  displayName: <FormattedMessage {...messages.empty} />,
  value: 'empty',
};

const isNotEmptyOperator = {
  id: 'notEmpty',
  displayName: <FormattedMessage {...messages.notEmpty} />,
  value: 'notEmpty',
};

export const criteriaOperatorsMap = {
  [OptionFormTypes.TYPE_CONTAINS]: containsOperators,
  [OptionFormTypes.TYPE_STRING]: stringOperators,
  [OptionFormTypes.TYPE_NUMBER_COMPARISON]: advancedComparisonOperators,
  [OptionFormTypes.TYPE_CURRENCY_COMPARISON]: advancedComparisonOperators,
  [OptionFormTypes.TYPE_DATE_COMPARISON_DEPRECATED]: dateOperators, // TODO: Remove when no longer in use per SPD-1623 - Greg S 1/10/20
  [OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS]: dateOperators,
  [OptionFormTypes.TYPE_ORDER_DATE_COMPARISON]: orderDateOperators,
  [OptionFormTypes.TYPE_DATE_COMPARISON]: advancedDateOperators,
  [OptionFormTypes.TYPE_IS_OR_ISNOT_MULTI_OPTIONS]: [isOperator],
  [OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER]: [isOperator, isNotOperator],
  [OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK]: [isOperator, isNotOperator, isEmptyOperator, isNotEmptyOperator],
};
